import { Container } from 'unstated';
import { isEmpty, isNumeric } from 'validator';
import { validateEmptyLanguageObject } from '../../../helpers/Validations/validateEmptyLanguageObject';
import { validateIncompleteLanguageObject } from '../../../helpers/Validations/validateIncompleteLanguageObject';
import { validateEmptyValue } from '../../../helpers/Validations/validateEmptyValue';

export interface IStaticDocumentDetailState {
  staticDocument: GQL.IStaticDocument;
  errors: IValidationErrors;
  warnings: IValidationWarnings;
  languages: Array<GQL.ILanguage>;
  currentLanguage: string;
}

export interface IStaticDocumentDetailStateProps {
  staticDocument: GQL.IStaticDocument;
  languages: Array<GQL.ILanguage>;
}

export interface IValidationErrors {
  title: string | undefined;
  html: string | undefined;
}

export interface IValidationWarnings {
  html: string | undefined;
}

export class StateContainer extends Container<IStaticDocumentDetailState> {
  
  constructor(props: IStaticDocumentDetailStateProps) {
    super();

    this.state = {
      staticDocument: props.staticDocument,
      errors: {} as IValidationErrors,
      warnings: {} as IValidationWarnings,
      languages: props.languages,
      currentLanguage: props.languages.map(l => l.value)[0]
    };

    this.preValidate();
  }

  public async preValidate() {
    if (this.state.staticDocument.id != undefined) {
      await this.validateField('html', 'language');
    }
  }

  public async onChange(key: string, val: any, language?: string) {
    const method = { ...this.state.staticDocument };

    if (language) {
      await this.setState({
        staticDocument: { ...method, [key]: { ...this.state.staticDocument[key], [language]: val } }
      });
    } else {
      await this.setState({ staticDocument: { ...method, [key]: val } });
    }

    await this.validateField(key, language ? 'language' : 'regular');
  }

  public async validate(): Promise<IValidationErrors> {
    const { staticDocument } = this.state;
    const errors = { ...this.state.errors };

    const message = 'This field is required';

    const validateEmpty = (input: string) => {
      if (input == undefined || isEmpty(input)) {
        return message;
      } else {
        return undefined;
      }
    };

    errors.title = validateEmpty(staticDocument.title);
    errors.html = validateEmptyLanguageObject(staticDocument.html, message);

    await this.setState({ errors });
    return errors;
  }

  private async validateField(fieldName: string, type: 'language' | 'regular') {
    const { staticDocument } = this.state;

    if (type == 'language') {
      const messageForEmpty = validateEmptyLanguageObject(staticDocument[fieldName], 'This field is required');
      if (messageForEmpty) {
        await this.setState({ errors: { ...this.state.errors, [fieldName]: messageForEmpty } });
        return;
      }

      const messageForIncomplete = validateIncompleteLanguageObject(
        staticDocument[fieldName],
        this.state.languages.map(l => l.value),
        'Not all languages are filled'
      );

      await this.setState({
        warnings: {
          ...this.state.warnings,
          [fieldName]: messageForIncomplete
        },
        errors: { ...this.state.errors, [fieldName]: messageForEmpty }
      });
    } else {
      const message = validateEmptyValue(staticDocument[fieldName], true);
      await this.setState({
        errors: { ...this.state.errors, [fieldName]: message }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/StaticDocuments/StaticDocumentDetail/StateContainer.ts